const MidAdList = () => import('@/modules/fwscad/midad/MidAdList.vue')
const TopAdList = () => import('@/modules/fwscad/topad/TopAdList.vue')
const BannerAdList = () => import('@/modules/fwscad/bannerad/BannerAdList.vue')
const FinanceAdList = () => import('@/modules/fwscad/financead/FinanceAdList.vue')
const RoadShowAdList = () => import('@/modules/fwscad/roadshowad/RoadShowAdList.vue')
const white = () => import('@/modules/fwscad/financead/white.vue')
const whiteroad = () => import('@/modules/fwscad/roadshowad/whiteroad.vue')
export default [
  {

    path: '/topad',
    name: 'topad',
    component: TopAdList,
    meta: {
      title: '首页轮播图',
      isBlack: true
    },
  },
  {

    path: '/midad',
    name: 'admanager',
    component: MidAdList,
    meta: {
      title: '中间广告位',
      isBlack: true
    },
  },
  {

    path: '/bannerad',
    name: 'bannerad',
    component: BannerAdList,
    meta: {
      title: '横幅广告位',
      isBlack: true
    },
  },
  {

    path: '/financead',
    name: 'financead',
    component: FinanceAdList,
    meta: {
      title: '投融资助手广告位',
      isBlack: true
    },
  },
  {

    path: '/roadshowad',
    name: 'roadshowad',
    component: RoadShowAdList,
    meta: {
      title: '路演助手广告位',
      isBlack: true
    },
  },
  {

    path: '/white',
    name: 'white',
    component: white,
    meta: {
      title: '',
    },
  },
  {

    path: '/whiteroad',
    name: 'whiteroad',
    component: whiteroad,
    meta: {
      title: '',
    },
  },
]
